import { getErrorMessage } from '@services/errors.service';
import TenantService from '@services/tenant/tenant.service';
import TenantConfigService from '@services/tenantConfig.service';
import AsyncButton from '@components/button/AsyncButton.component';
import produce from 'immer';
import { PropsWithChildren, useCallback, useEffect, useMemo, useState } from 'react';
import { Alert, Collapse, Modal, Offcanvas, ProgressBar, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { CopyBlock, atomOneLight } from "react-code-blocks";
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import BackgroundService from '@services/bg.service';
import useGlobalState from '@stores/global.state';
import pliablemark from '@assets/images/pliable/brand_mark_orange.png';
import snowflakemark from '@assets/images/snowflake_logo.png';
import dbtmark from '@assets/images/dbt.png';
import styled, { css } from 'styled-components';
import ApiService from '@services/api/api.service';
import toast from '@services/toast.service';
import PageStructure, { Main, PageContent, PageContentNoSidebar, PageSidebar, Pane, PaneContent, PaneContentSidebar } from '@pages/PageStructure.component';
import { useHotkeys } from 'react-hotkeys-hook';
import { enterDraftMode, invalidateEverything, queryClient, toggleThenaWidget, useBillingAccount } from '@stores/data.store';
import ConfigService, { Config, SurveyAnswers, SurveyDataSources } from '@services/config/config.service';
import { Updater, useImmer } from 'use-immer';
import SnowflakeMenuScreen from '@assets/images/onboarding/snowflake_menu.png';
import SnowflakeMenuScreen2 from '@assets/images/onboarding/snowflake_menu2.png';
import SnowflakeMenuScreen3 from '@assets/images/onboarding/snowflake_menu3.png';

import PliableLogo from '@assets/images/pliable/logo_with_text_black.png';
import Danger from '@components/statusIndicators/Danger.component';
import SuccessAlert from '@components/statusIndicators/SuccessAlert.component';
import { EventScheduledEvent, InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { useAuthState } from '@services/auth/auth.service';
import { useDebouncedCallback } from 'use-debounce';
import { useQuery } from 'react-query';
import moment from 'moment';
import PliableLoader from '@components/loaders/PliableLoader.component';
import BrandMark from '@assets/images/pliable/brand_mark_orange.svg';
import TrackingService from '@services/tracking.service';
import TenantPicker from '@components/tenant/TenantPicker.component';
import { isValidSnowflakeURL } from '@services/url.service';
import CorePlanPicker from '@components/billing/PlanPicker.component';
import BillingAccountORM from '@models/billingAccount';
import EmbeddedCheckoutForm from '@components/billing/EmbeddedCheckout.component';
import CurrentBillingPlan from '@components/billing/CurrentPlan.component';
import Dropdown, { MultiDropdown } from '@components/form/Dropdown.component';

import pliableLogo from '@assets/images/pliable/logo_with_text_black.png'
import InfoAlert from '@components/statusIndicators/InfoAlert.component';
import LoadingCard from '@components/card/LoadingCard.component';
import TOSModal from '@components/alert/TOSModal.component';
import Warning from '@components/statusIndicators/Warning.component';
import AiOnboarder from '@components/onboarding/AiOnboarder.component';
import { useFeatureFlagValue } from '@services/featureFlags/featureFlag.service';

// step order
enum WizardStep {
    Survey = 'survey',
    Warehouse = 'warehouse', 
    Finalize = 'finalize',
    Plan = 'plan', 
    Billing = 'billing',
    Complete = 'complete'
}

const stepsOrder = [WizardStep.Survey, WizardStep.Warehouse, WizardStep.Finalize,];


export const ButtonGrid = styled.div`
    button {
        
        display: inline-block;
        margin: .5rem;
        background-color: white;
        font-weight: 300;
        font-family: "Poppins";
        padding: 0px 1rem;

        border: 1px solid #D9D9D9;
        border-radius: 10px;
        box-shadow: 0px 2px 3px 0px #0000001A;
        height: 50px;
        line-height: 50px;

        .inner {
            display: flex;
            align-items: center;
        }

        
        img {
            max-width: 100px;
            max-height: 90%;
        }

        &.active {
            color: white;
            background-color: var(--ct-primary);

            i {
                color: white !important;
            }

            img {
                filter: brightness(0) invert(1);
            }
            &:hover {
                background-color: var(--ct-primary) !important;
            }
        }

        &:hover {
            background-color: #eee;
        }

    }
`



const HeaderImage = styled.img`
max-height: 50px;
`
interface SnowflakeDetails {
    auth_method: string;
    host: string;
    username: string;
    password: string;
    private_key: string;
    private_key_passphrase: string;
    database: string;
    query_warehouse: string;
    loading_warehouse: string;
    build_warehouse: string;
    role: string;
    loader_username?: string;
    loader_password?: string;
    loader_private_key?: string;
    loader_private_key_passphrase?: string;
    loader_database?: string;
    loader_role?: string;
}

export const NavBar = styled.div`
    height: 50px;
    border-bottom: solid 1px var(--ct-border-color);
    display: flex;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;

    img {
        max-height: 30px;
    }
`

const ProgressBarWrapper = styled.div`
height: 10px;
width: 100%;

div.progress {
    border-radius: 0px;
    height: 10px;
}
`

const StepHeaderStyles = styled.div<{active?: boolean;}>`
display: flex;

margin-bottom: 20px;

h2 {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 5px;
}

h3 {
    font-family: Poppins;
    font-size: 12px;
    font-weight: 300;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
}

.step-number {
    width: 25px;
    height: 25px;
    border: 2px solid #00A1E0;
    border-radius: 13px;
    color: #00A1E0;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;


}

&.active {
    .step-number {
        color: #fff;
        background-color: #00A1E0;
    }
}

&.complete {
    .step-number {
        color: #fff;
        background-color: var(--ct-success);
    }
}
`

const AnswerReview = styled.div`
border: solid 1px var(--ct-border-color);
font-size: 18px;
border-radius: 5px;
padding: 1rem;
`

interface DbtIconProps {
    className?: string;
}


const DbtIcon = (props: DbtIconProps) => {
    return <img className={props.className} style={{maxWidth: '15px'}} src={dbtmark}/>
}

const DBTInfo = (props: PropsWithChildren) => {
    return <div className="mb-1 font-13">
        <span className="me-1"><DbtIcon/></span> {props.children}
    </div>
}

const HelpStyles = styled.div`
img {
    max-width: 100%;
}
`;


const toolOptions = [
    {
        label: 'Snowflake',
        value: 'snowflake'
    },
    {
        label: 'BigQuery',
        value: 'bigquery'
    },
    {
        label: 'Redshift',
        value: 'redshift'
    },
    {
        label: 'Postgres',
        value: 'postgres'
    },
    {
        label: 'MySQL',
        value: 'mysql'
    },
    {
        label: 'MongoDB',
        value: 'mongodb'
    },
    {
        label: 'DynamoDB',
        value: 'dynamodb'
    },
    {
        label: 'Databricks',
        value: 'databricks'
    },
    {
        label: 'DBT',
        value: 'dbt'
    },
    {
        label: 'Fivetran',
        value: 'fivetran'
    },
    {
        label: 'Portable',
        value: 'portable'
    },
    {
        label: 'Stitch',
        value: 'stitch'
    },
    {
        label: 'Airbyte',
        value: 'airbyte'
    },
    {
        label: 'Github',
        value: 'github'
    },
    {
        label: 'Prefect',
        value: 'prefect'
    },
    {
        label: 'Orchestra',
        value: 'orchestra'
    },
    {
        label: 'Power BI',
        value: 'powerbi'
    },
    {
        label: 'Tableau',
        value: 'tableau'
    },
    {
        label: 'Looker',
        value: 'looker'
    },
    {
        label: 'Metabase',
        value: 'metabase'
    },
    {
        label: 'Coalesce',
        value: 'coalesce'
    },
    {
        label: 'Monte Carlo',
        value: 'montecarlo'
    },
    
    {
        
        label: 'Other',
        value: 'other'
    }
].sort((a, b) => a.label.localeCompare(b.label));

interface SnowflakeFormProps {
    snowflakeDetails: SnowflakeDetails;
    credsAreValid: boolean;
    tenantConfigId: string;
    showPliableHostedSnowflakeCode: boolean;
    onChange: (attr: keyof SnowflakeDetails, value: any) => any;
    onCredentialsAreValid: (areValid: boolean) => any;
    onNextAfterValidation: () => any;
}

const SnowflakeSetupForm = ({ onNextAfterValidation, snowflakeDetails, onChange, tenantConfigId, onCredentialsAreValid, showPliableHostedSnowflakeCode, credsAreValid }: SnowflakeFormProps) => {
    const validHost = useMemo(() => {
        const isValid = isValidSnowflakeURL(snowflakeDetails.host);
        return isValid;
    }, [snowflakeDetails.host]);

    const formIsValid = useMemo(() => {
        return validHost && !!snowflakeDetails.username && !!snowflakeDetails.database && !!snowflakeDetails.role && !!snowflakeDetails.query_warehouse;
    }, [snowflakeDetails, validHost]);

    const [savingConfig, setSavingConfig] = useState(false);
    const [saveConfigError, setSaveConfigError] = useState('');
    const [generatingScript, setGeneratingScript] = useState(false);
    const [generatingScriptError, setGeneratingScriptError] = useState('');
    const [setupSql, setSetupSql] = useState('');
    const [showScriptModal, setShowScriptModal] = useState(false);
    const [activationCode, setActivationCode] = useState('');
    const [creatingHostedSnowflake, setCreatingHostedSnowflake] = useState(false);

    const [testingCredentials, setTestingCredentials] = useState(false);
    const [credentialsError, setCredentialsError] = useState('');
    const [credentialsWarning, setCredentialsWarning] = useState('');

    const generateScript = useCallback(async () => {
        setGeneratingScript(true);

        try {
            const { snowflake_setup_sql } : any = await TenantConfigService.getInstance().showSetupScript(tenantConfigId);
            setSetupSql(snowflake_setup_sql);
            setShowScriptModal(true);
        } catch (err) {
            setGeneratingScriptError(getErrorMessage(err));
        } finally {
            setGeneratingScript(false);
        }
        
    }, [snowflakeDetails, tenantConfigId]);

    const saveSnowflakeDetails = useCallback(async (doGenerateScript: boolean = false) => {
        setSavingConfig(true);

        try {
            await TenantConfigService.getInstance().saveSnowflakeDetails(tenantConfigId, snowflakeDetails);
            if (doGenerateScript) {
                await generateScript();
            }
        } catch (err) {
            setSaveConfigError(getErrorMessage(err));
        } finally {
            setSavingConfig(false);
        }
        
    }, [snowflakeDetails, tenantConfigId, generateScript]);

    const createPliableHostedSnowflake = useCallback(async () => {
        setCreatingHostedSnowflake(true);

        try {
            await TenantConfigService.getInstance().createHostedSnowflake(tenantConfigId, activationCode);
            ConfigService.getInstance().loadConfig(); // need to flush tenant config
            onCredentialsAreValid(true);
        } catch (err) {
            setSaveConfigError(getErrorMessage(err));
        } finally {
            setCreatingHostedSnowflake(false);
        }
    }, [activationCode, tenantConfigId]);


    const [useDBT, setUseDBT] = useState<boolean|undefined>(undefined);
    
    const testCredentials = useCallback(async () => {
        // Save credentials here in case they are not using the setup script
        setTestingCredentials(true);

        onCredentialsAreValid(false);
        setCredentialsError('');
        try {
            await saveSnowflakeDetails(false);
            const { has_db_access } : any = await TenantConfigService.getInstance().verifySnowflakeAccess(tenantConfigId);

            if (!has_db_access) {
                throw new Error('Unable to connect to Snowflake.');
            } 
            const {job_id} : any = await TenantConfigService.getInstance().initInfrustructure(tenantConfigId);
            const {infra} : Config = await BackgroundService.getInstance().waitForJob(job_id);


            if (infra.is_ready) {
                onCredentialsAreValid(true);
                if (!infra.snowpipe.setup_complete) {
                    setCredentialsWarning('Your Snowflake account is connected, but we were unable to set up the infrastructure for file uploads. You may need to grant the Pliable user the necessary permissions to create stages and pipes. Error: ' + infra.snowpipe.setup_error);
                }
            } else {
                throw new Error('Error setting up infrastructure.');
            }
        } catch (err) {
            setCredentialsError(getErrorMessage(err));
            onCredentialsAreValid(false);
        } finally {
            setTestingCredentials(false);
        }
    }, [snowflakeDetails, tenantConfigId, saveSnowflakeDetails]);
    const [showAll, setShowAll] = useState(false);
    const [showHelp, setShowHelp] = useState(false);

    return <div style={{textAlign: 'left'}}>
        <Modal show={showScriptModal} size="lg" onHide={() => setShowScriptModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Setup Script</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InfoAlert>This script will create all of the resources (warehouses, databases, users, roles, etc) that Pliable needs to operate in your Snowflake account.</InfoAlert>
                <p>
                    Log into your Snowflake account and run the following script in a new worksheet. Make sure "All Queries" is checked. When you're done, close this window and click on "Validate Connection".
                </p>
                <div style={{maxHeight: 400, overflowX: 'scroll'}} className="mb-3">
                    <CopyBlock
                        text={setupSql}
                        language="sql"
                        showLineNumbers={false}
                        theme={atomOneLight}
                        codeBlock={true}
                    />
                </div>
            </Modal.Body>
        </Modal>
        <Offcanvas show={showHelp} onHide={() => setShowHelp(false)} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Help</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Pane>
                    <PaneContent>
                        <HelpStyles className="p-3">
                            <p>To get your Snowflake host name:</p>
                            <h4>1. Log into your Snowflake account</h4>
                            
                            <h4>2. Open up a new SQL worksheet</h4>
                            <p>Go to "Projects" in the sidebar, then click on the arrow next to the blue "+" button at the top right of your screen. Select "SQL Worksheet".</p>
                            <h4>3. Run the SQL command</h4>
                            <p>In the SQL editor, paste the following command:</p>
                            <pre><code>USE ROLE ACCOUNTADMIN;
SELECT 'https://' || LOWER(CURRENT_ORGANIZATION_NAME() || '-' || CURRENT_ACCOUNT_NAME()) || '.snowflakecomputing.com';</code></pre>
                            
                        </HelpStyles>
                    </PaneContent>
                </Pane>
                
            </Offcanvas.Body>
        </Offcanvas>

        {showPliableHostedSnowflakeCode && <>
            <h4>Let Pliable create a Snowflake account for me.</h4>
            <p className="text-muted font-13">Your Pliable account will incure additional charges based off your usage of snowflake.</p>

            <Form.Group className="mb-3">
                <Form.Label className="small">Activation Code</Form.Label>
                <Form.Control
                    name="activation_code"
                    type="password"
                    placeholder=""
                    value={activationCode} 
                    onChange={(e) => setActivationCode(e.target.value)}
                />
                <Form.Text></Form.Text>
            </Form.Group>
            <hr />

            {!credsAreValid && 
                <AsyncButton
                    variant="pliable"
                    icon='mdi mdi-database-edit-outline'
                    disabled={!activationCode}
                    loading={creatingHostedSnowflake}
                    onClick={() => createPliableHostedSnowflake()}
                    text="Create Snowflake Account"
                />
            }

            {creatingHostedSnowflake && (
                <div>
                    <Form.Text>
                        Setting up new Snowflake account for you. This may take up to 5 minutes.
                    </Form.Text>
                </div>

            )}

            {!creatingHostedSnowflake && credsAreValid && <div className="mt-2">
                <SuccessAlert>
                    <div className="flex-1">Connection successful!</div>
                    <button className="btn btn-success" onClick={onNextAfterValidation}>Next</button>
                    
                </SuccessAlert>

            </div>
            }
            

        </>}

        {!showPliableHostedSnowflakeCode && <>

            <h3 className="mb-0">Snowflake Account Details</h3>
            <p className="text-muted">We'll use these details to generate a script for you to run on your Snowflake account, which will create all of the resources Pliable needs to operate. The only required field is the <strong>host</strong>.</p>

            <Form.Group className="mb-3">
                <Form.Label>Host</Form.Label>
                <Form.Control
                    name="host"
                    type="text"
                    placeholder="your-account.snowflakecomputing.com"
                    value={snowflakeDetails.host}
                    isValid={validHost} 

                    onChange={(e) => onChange('host', e.target.value)}
                />
                <Form.Text>
                    This needs to be the "regionless" hostname in order to work with Snowflake's newer features, such as the Cortex API. <a role="button" href="#" onClick={() => setShowHelp(true)}>Where do I find this?</a>
                </Form.Text>
            </Form.Group>
            <div className="mb-2">
                <Form.Check
                    type="switch"
                    checked={showAll}
                    label="Show Advanced Configuration"
                    onChange={(e) => setShowAll(e.target.checked)}
                />
            </div>
            
            <Collapse in={showAll}>
                <div className="shadow-box p-3">
                    <h3>Advanced Configuration</h3>
                        <Form.Group className="mb-3">
                            <Form.Label>Authentication Method</Form.Label>
                            <Dropdown
                                options={[
                                    {
                                        label: 'Username/Password',
                                        value: 'PASSWORD'
                                    },
                                    {
                                        label: 'Keypair',
                                        value: 'KEYPAIR'
                                    }
                                ]}
                                selected={snowflakeDetails.auth_method}
                                onChange={(val) => onChange('auth_method', val)}
                            />
                        </Form.Group>
                        <h4>Build Credentials</h4>
                        <p className="text-muted">These credentials are used for building your models and running queries. It's best practice to keep these separate from your loader credentials.</p>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            
                            <Form.Control
                                name="username"
                                type="text"
                                placeholder=""
                                value={snowflakeDetails.username}

                                onChange={(e) => onChange('username', e.target.value)}
                            />
                        </Form.Group>
                        {snowflakeDetails.auth_method === 'KEYPAIR' && <>
                            <Form.Group className="mb-3">
                                <Form.Label>Private Key</Form.Label>
                                <Form.Control as="textarea" value={snowflakeDetails.private_key} onChange={(e) => onChange('private_key', e.target.value)}/>
                                <Form.Text>Paste the entire private key here, including "-----BEGIN PRIVATE KEY-----" and "-----END PRIVATE KEY-----". For more information about using key-pair auth with Snowflake, please visit the <a target="_blank" href="https://docs.snowflake.com/en/user-guide/key-pair-auth">Snowflake documentation</a>.</Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Private Key Passphrase (Optional)</Form.Label>
                                <Form.Control
                                    name="private_key_passphrase"
                                    type="password"
                                    placeholder=""
                                    value={snowflakeDetails.private_key_passphrase}

                                    onChange={(e) => onChange('private_key_passphrase', e.target.value)}
                                />
                            </Form.Group>
                        </>}
                        {snowflakeDetails.auth_method === 'PASSWORD' && <>
                            <Form.Group className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    name="password"
                                    type="password"
                                    placeholder=""
                                    value={snowflakeDetails.password}

                                    onChange={(e) => onChange('password', e.target.value)}
                                />
                                <Form.Text>Leave blank and we will automatically generate one for you.</Form.Text>
                            </Form.Group>
                        </>}
                       
                        <Form.Group className="mb-3">
                            <Form.Label>Database</Form.Label>
                            <div></div>
                            <Form.Control
                                name="database"
                                type="text"
                                placeholder=""
                                value={snowflakeDetails.database}

                                onChange={(e) => onChange('database', e.target.value)}
                            />
                            <Form.Text>
                                Enter the name of the database where Pliable should store its data
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Warehouse (Building)</Form.Label>
                            
                            <Form.Control
                                name="build_warehouse"
                                type="text"
                                placeholder=""
                                value={snowflakeDetails.build_warehouse}

                                onChange={(e) => onChange('build_warehouse', e.target.value)}
                            />
                            <Form.Text>
                                Enter the name of the warehouse Pliable should use for building your models.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Warehouse (Querying)</Form.Label>
                            <Form.Control
                                name="query_warehouse"
                                type="text"
                                placeholder=""
                                value={snowflakeDetails.query_warehouse}

                                onChange={(e) => onChange('query_warehouse', e.target.value)}
                            />
                            <Form.Text>
                                Enter the name of the warehouse Pliable should use for querying your models. It's best practice to keep these separate so you don't compete for resources with the scheduled build processes.
                            </Form.Text>
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Role</Form.Label>
                            <Form.Control
                                name="role"
                                type="text"
                                placeholder=""
                                value={snowflakeDetails.role}

                                onChange={(e) => onChange('role', e.target.value)}
                            />
                            <Form.Text>
                                Enter the name of the role Pliable should use when interacting with Snowflake. 
                            </Form.Text>
                        </Form.Group>
                        <hr />
                    <h4>Loading Credentials (Optional)</h4>
                    <p className="text-muted">If you are using Pliable's managed ETL functionality, you will also need to provide credentials for loading data into Snowflake.</p>
                    <Form.Group className="mb-3">
                        <Form.Label>User</Form.Label>
                        <Form.Control
                            name="loader_user"
                            type="text"
                            placeholder=""
                            value={snowflakeDetails.loader_username}

                            onChange={(e) => onChange('loader_username', e.target.value)}
                        />
                        <Form.Text>
                            Enter a username to use for loading data into your Snowflake
                        </Form.Text>
                    </Form.Group>
                    {snowflakeDetails.auth_method === 'KEYPAIR' && <>
                            <Form.Group className="mb-3">
                                <Form.Label>Private Key</Form.Label>
                                <Form.Control as="textarea" value={snowflakeDetails.loader_private_key} onChange={(e) => onChange('loader_private_key', e.target.value)}/>
                                <Form.Text>Paste the entire private key here, including "-----BEGIN PRIVATE KEY-----" and "-----END PRIVATE KEY-----". For more information about using key-pair auth with Snowflake, please visit the <a target="_blank" href="https://docs.snowflake.com/en/user-guide/key-pair-auth">Snowflake documentation</a>.</Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Private Key Passphrase (Optional)</Form.Label>
                                <Form.Control
                                    name="loader_private_key_passphrase"
                                    type="password"
                                    placeholder=""
                                    value={snowflakeDetails.loader_private_key_passphrase}

                                    onChange={(e) => onChange('loader_private_key_passphrase', e.target.value)}
                                />
                            </Form.Group>
                        </>}
                        {snowflakeDetails.auth_method === 'PASSWORD' && <>
                            <Form.Group className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    name="loader_password"
                                    type="password"
                                    placeholder=""
                                    value={snowflakeDetails.loader_password}

                                    onChange={(e) => onChange('loader_password', e.target.value)}
                                />
                                <Form.Text>Leave blank and we will automatically generate one for you.</Form.Text>
                            </Form.Group>
                        </>}
                    <Form.Group className="mb-3">
                        <Form.Label>Database</Form.Label>
                        <Form.Control
                            name="loader_database"
                            type="text"
                            placeholder=""
                            value={snowflakeDetails.loader_database}

                            onChange={(e) => onChange('loader_database', e.target.value)}
                        />
                        <Form.Text>
                            Enter the name of the database for housing raw data ingested from your data sources.
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Role</Form.Label>
                        <Form.Control
                            name="loader_role"
                            type="text"
                            placeholder=""
                            value={snowflakeDetails.loader_role}

                            onChange={(e) => onChange('loader_role', e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Warehouse (Loading)</Form.Label>
                        <Form.Control
                            name="loading_warehouse"
                            type="text"
                            placeholder=""
                            value={snowflakeDetails.loading_warehouse}

                            onChange={(e) => onChange('loading_warehouse', e.target.value)}
                        />
                        <Form.Text>
                            Enter the name of the warehouse Pliable should use for loading in data.
                        </Form.Text>
                    </Form.Group>

                </div>
            </Collapse>
            <p className="text-muted">Once you're ready, generate and run the setup script to connect Pliable to your Snowflake.</p>     
            <AsyncButton
                variant="pliable"
                icon='mdi mdi-database-edit-outline'
                disabled={!formIsValid}
                loading={savingConfig}
                onClick={() => saveSnowflakeDetails(true)}
                text="Generate Setup Script"
            />
            <hr />
            <h3 className="mb-0">Validate Connection</h3>
            <p className="text-muted">Once you've run the script, we just need to validate the connection.</p>                       
            
            <AsyncButton
                variant="primary"
                icon='mdi mdi-database-edit-outline'
                disabled={!formIsValid}
                loading={testingCredentials}
                onClick={() => testCredentials()}
                text="Validate Connection"
            />
            {testingCredentials && (
                <div>
                    <Form.Text>
                        We're running a few different checks, which may take up to 30 seconds.
                    </Form.Text>
                </div>
                
            )}
            {credentialsError && (
                <>
                    <p>
                        <strong className="text-danger">Oops!</strong> We were unable to connect to your Snowflake. Please check your credentials and make sure the setup script ran successfully.
                    </p>
                    <Danger>
                        {credentialsError}
                    </Danger>
                </>
            )}
            {credentialsWarning && (
                <div className="mt-2">
                    <Warning><div>{credentialsWarning}</div></Warning>
                </div>
            )}
            {!testingCredentials && credsAreValid && <div className="mt-2">
                <SuccessAlert>
                    <div className="flex-1">Connection successful!</div>
                    <button className="btn btn-success" onClick={onNextAfterValidation}>Next</button>
                    
                </SuccessAlert>

            </div>
            }
        </>}
        
                    
    </div>
}




const INDUSTRY_OPTIONS = [
    'Construction',
    'Consulting',
    'E-Commerce',
    'Finance',
    'Government',
    'Healthcare',
    'Hospitality',
    'iGaming',
    'Insurance',
    'Lending',
    'Manufacturing',
    'Real Estate',
    'Software',
    'Other',
];

const USE_CASE_OPTIONS = [
    'Affiliate Marketing',
    'Asset Performance',
    'Customer Satisfaction',
    'Financial Health',
    'Employee Performance',
    'Marketing Funnel',
    'Product Usage',
    'Team Productivity',
    'Sales Funnel',
    'SEO',
    'Supply Chain',
    'Other',
];

interface ToolGroup {
    name: string;
    prompt: string;
    otherValue: string;
    otherKey: keyof SurveyDataSources;
    toolOptions: string[];
}

const TOOL_GROUPS: {
    [key: string]: ToolGroup;
} = {
    'AD_PLATFORMS': {
        name: 'Ad Platforms',
        prompt: 'Connect to your advertising platform sso Pliable can pull in information about your ad campaigns and their performance.',
        toolOptions: [
            'Meta Ads',
            'Google Ads',
            'LinkedIn Ads',
            'Bing Ads',
            'Other Ad Platform',
        ],
        otherKey: 'otherAdPlatform',
        otherValue: 'Other Ad Platform'
    },
    'AFFILIATE_MARKETING': {
        name: 'Affiliate Marketing Platforms',
        prompt: 'Connect to your affiliate marketing platform so Pliable can pull in information about your commissions.',
        otherValue: 'Other Affiliate Platform',
        otherKey: 'otherAffiliatePlatform',
        toolOptions: [
            'Affiliate Window',
            'Commission Junction',
            'Impact Radius',
            'Link Connector',
            'Partnerize',
            'Pepperjam',
            'Rakuten',
            'Skimlinks',
            'Other Affiliate Platform',
        ]
    },
    'ERPS': {
        name: 'ERP',
        prompt: 'Connect to your ERP so Pliable can pull in information about projects, inventory, vendors, and accounting.',
        otherValue: 'Other ERP',
        otherKey: 'otherERP',
        toolOptions: [
            'Netsuite',
            'SAP',
            'Viewpoint Spectrum',
            'Other ERP',
        ]
    },
    'HR': {
        name: 'HR Platforms',
        prompt: 'Connect to your HR platform so Pliable can pull in information about your employees, salaries, and performance.',
        toolOptions: [
            'Rippling',
            'Gusto',
            'Other HR Platform',
        ],
        otherKey: 'otherHRPlatform',
        otherValue: 'Other HR Platform',
    },
    'SELLING_PLATFORMS': {
        name: 'Selling Platforms',
        prompt: 'Connect to your selling platforms so Pliable can pull in information about your sales, performance by keyword, etc.',
        toolOptions: [
            'Amazon',
            'Etsy',
            'Shopify',
            'Other Selling Platform',
        ],
        otherKey: 'otherSellingPlatform',
        otherValue: 'Other Selling Platform',
    },
    'CRMS': {
        name: 'CRMs',
        prompt: 'Connect your CRM(s) to bring in information about your customers, sales & marketing activities, and conversions.',
        toolOptions: [
            'Hubspot',
            'Pipedrive',
            'Salesforce',
            'Other CRM',
        ],
        otherKey: 'otherCRM',
        otherValue: 'Other CRM',
    },
    'PRODUCT_DATABASES': {
        name: 'Application Databases',
        prompt: "Connect to your application database (preferably a read-replica) so Pliable can pull in information about your product usage.",
        toolOptions: [
            'DynamoDB',
            'MongoDB',
            'MySQL',
            'PostgreSQL',
            'Other Database',
        ],
        otherKey: 'otherProductDatabase',
        otherValue: 'Other Database',
    },
    'ACCOUNTING': {
        name: 'Accounting',
        prompt: 'Connect to your accounting system to Pliable can pull in information about your revenue and expenses.',
        toolOptions: [
            'Bill.com',
            'Quickbooks',
            'Stripe',
            'Xero',
            'Other Accounting System',
        ],
        otherKey: 'otherAccountingTool',
        otherValue: 'Other Accounting System',
    },
    'SPORTSBOOK': {
        name: 'Sports Book',
        prompt: 'Connect your sports book to pull in information about players, bets, and odds.',
        toolOptions: [
            'Kambi',
            'Other Sportsbook'
        ],
        otherKey: 'otherSportsbook',
        otherValue: 'Other Sportsbook',
    }, 
    'SEO': {
        name: 'SEO',
        prompt: 'Connect to your SEO tools to report on your website performance on search engines.',
        toolOptions: [
            'Google Search Console',
            'Google Analytics',
            'Segment',
            'Rudderstack',
            'A HREFS',
            'Other SEO Tool',
        ],
        otherKey: 'otherSEO',
        otherValue: 'Other SEO Tool',
    },
    'PAM': {
        name: 'iGaming PAM',
        prompt: 'Connect your PAM to pull in player and balance information.',
        toolOptions: [
            'White Hat Gaming',
            'Other PAM',
        ],
        otherKey: 'otherPAM',
        otherValue: 'Other PAM',
    },
    'LMS': {
        name: 'Loan Management System',
        prompt: 'Loans performance, payment history, default rate, etc.',
        toolOptions: [
            'Nortridge',
            'Totality',
            'Other LMS',
        ],
        otherKey: 'otherLMS',
        otherValue: 'Other LMS',
    },
    'OUTREACH': {
        name: 'Customer Outreach Tools',
        prompt: 'Opens, clicks, connections, etc for outbound (email, phone, direct mail, in-app).',
        toolOptions: [
            'Braze',
            'Iterable',
            'Klaviyo',
            'Mailchimp',
            'Sendgrid',
            'Twilio',
            'Other Outreach Tool',
        ],
        otherKey: 'otherOutreachTool',
        otherValue: 'Other Outreach Tool',

    },
    'ANALYTICS': {
        name: 'Analytics Tools',
        prompt: 'Product analytics, like logins, feature usage, etc.',
        toolOptions: [
            'AppsFlyer',
            'FullStory',
            'Google Analytics',
            'Pendo',
            'Rudderstack',
            'Segment',
            'Other Analytics Tool',
        ],
        otherKey: 'otherAnalyticsTool',
        otherValue: 'Other Analytics Tool'
    }, 
    'PRODUCTIVITY': {
        name: 'Productivity & Project Management Tools',
        prompt: 'Project efficiency, workload, resource-level performance',
        toolOptions: [
            'Airtable',
            'Asana',
            'ClickUp',
            'Gitlab',
            'GitHub',
            'JIRA',
            'Monday.com',
            'Other Productivity Tool',
        ],
        otherKey: 'otherProductivityTool',
        otherValue: 'Other Productivity Tool',
    }, 
    'SUPPORT': {
        name: 'Support Tools',
        prompt: 'Customer satisfaction, open tickets, call center volume, etc.',
        toolOptions: [
            'Aircall',
            'Open Phone',
            'Zendesk',
            'Zoom Contact Center',
            'Other Support Tool',
        ],
        otherKey: 'otherSupportTool',
        otherValue: 'Other Support Tool',
    }

}


const OnboardingStep = styled.div`
text-align: center;
width: 1000px;
margin: 100px auto;
opacity: 1.0;

h1, h1 {
    color: #0F0E31;
}
h1 {
    font-weight: 400;
    line-height: 30px;
}

h2 {
    font-weight: 200;
}

&.faded {
    opacity: 0.0;
}

input.custom-value {
    width: 200px;
    margin: 0px auto;
    border-radius: 10px;
}

textarea.custom-value {
    margin: 0px auto;
    width: 300px;
    border-radius: 10px;
}

transition: opacity 0.15s ease-in-out;
-webkit-transition: opacity 0.15s ease-in-out;
`

const AIOrbStyles = styled.div`
width: 100px;
height: 100px;
img {
    width: 100%;
    height: 100%;
}


margin: 0px auto 25px auto;
`

const AIOrb = () => {
    return <AIOrbStyles>
        <img src={BrandMark}/>
    </AIOrbStyles>
}


const NextPreviousButton = styled.button`
border: none;
background: none;
color: var(--ct-primary);
font-weight: bold;
font-family: "Poppins";
font-size: 26px;
&:hover {
    text-decoration: underline;
}

&:disabled {
    color: #ccc;
    &:hover {
        text-decoration: none;
    }
}
`

const OnboardingOption = styled.div<{selected?: boolean}>`
&:hover {
    background: var(--ct-light);
    cursor: pointer;
}

${props => props.selected && css`
    background-color: var(--ct-primary);
    color: white !important;

    h3 {
    color: white !important;}

    &:hover {
        background-color: var(--ct-primary);
    }
`}
`

export const humanReadableList = function(l: string[]): string {
    const uniqueList = l.filter((a: string, idx: number, arr: string[]) => {
        return arr.indexOf(a) === idx;
    })
    if (uniqueList.length == 0) {
        return '_______';
    }
    if (uniqueList.length == 1) {
        return l[0];
    }

    if (uniqueList.length == 2) {
        return l[0] + ' and ' + l[1];
    }

    return uniqueList.slice(0, -1).join(', ') + ', and ' + uniqueList[uniqueList.length - 1];
}

const SummaryLink = styled.a`
color: var(--pliable-yellow);
font-weight: bold;
&:hover {
    text-decoration: underline;
}
`

const OnboardingWizardPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const setDataLibraryEnabled = useGlobalState((state: any) => state.setLibraryEnabled);

    const aiOnboardingEnabled = useFeatureFlagValue('ai-onboarder', false);

    setDataLibraryEnabled(false);
    const { isLoading: loadingBillingAccount, data: billingAccount, refetch: refetchBillingAccount } = useBillingAccount(searchParams.get('session_id') != null);
    const [snowflakeDetails, setSnowflakeDetails] = useState<SnowflakeDetails>({
        auth_method: 'KEYPAIR',
        private_key: '',
        private_key_passphrase: '',
        host: '',
        username: 'PLIABLE_USER',
        password: '',
        database: 'PLIABLE_DATABASE',
        role: 'PLIABLE_ROLE',
        query_warehouse: 'PLIABLE_QUERY_WAREHOUSE',
        loading_warehouse: 'PLIABLE_LOADING_WAREHOUSE',
        build_warehouse: 'PLIABLE_BUILD_WAREHOUSE',
        loader_username: 'PLIABLE_LOADER_USER',
        loader_database: 'PLIABLE_LOADER_DATABASE',
        loader_role: 'PLIABLE_LOADER_ROLE',
    
    });

    const [answers, setAnswers] = useImmer<SurveyAnswers>({
        dataTeamSize: '',
        industry: {
            selection: '',
            otherValue: '',
        },
        role: '',
        otherRole: '',
    })

    const [tenantConfigId, setTenantConfigId] = useState('');

    const [tenantInfraIsReady, setTenantInfraIsReady] = useState(false);
    const [showPliableHostedSnowflakeCode, setShowPliableHostedSnowflakeCode] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useHotkeys('ctrl+h', () => {
        if(!tenantInfraIsReady){
            setShowPliableHostedSnowflakeCode(!showPliableHostedSnowflakeCode);
            console.log('Showing hosted snowflake code');
        } else {
            console.log('Infra is already ready');
        }
    }, [tenantInfraIsReady, showPliableHostedSnowflakeCode]);

    const loadData = async () => {
        setLoading(true);
        try {
            const {
                tenantRegistration,
                tenant_config,
                connection_creds,
                loader_creds
            } : any = await TenantService.getInstance().getTenantRegistration();
    
            setTenantConfigId(tenant_config.id);
            if (tenant_config.onboarding_info) {
                
                setAnswers(tenant_config.onboarding_info);

            }
            setTenantInfraIsReady(tenant_config.infra.is_ready);
            setUseTemplate(tenant_config.last_used_template);
            setSnowflakeConnectionIsValid(tenant_config.infra.is_ready);

            setSnowflakeDetails(produce(snowflakeDetails, draft => {
                return {
                    auth_method: connection_creds.auth_method || 'PASSWORD',
                    private_key: connection_creds.private_key || '',
                    private_key_passphrase: connection_creds.private_key_passphrase || '',
                    host: connection_creds.host,
                    username: connection_creds.username,
                    password: connection_creds.password,
                    database: connection_creds.database,
                    role: connection_creds.role,
                    query_warehouse: connection_creds.query_warehouse,
                    loading_warehouse: loader_creds.loading_warehouse,
                    build_warehouse: connection_creds.build_warehouse,
                    loader_role: loader_creds.role,
                    loader_username: loader_creds.username,
                    loader_password: loader_creds.password,
                    loader_private_key: loader_creds.private_key || '',
                    loader_private_key_passphrase: loader_creds.private_key_passphrase || '',
                    loader_database: loader_creds.database,
                };
            }));
        } catch (err) {
            setError(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
        
    }

    useEffect(() => {
        loadData();
    }, []);

    const [savingDatabaseChoice, setSavingDatabaseChoice] = useState(false);
    const [useTemplate, setUseTemplate] = useState('');
    const [savingConfig, setSavingConfig] = useState(false);
    const [configSaved, setConfigSaved] = useState(false);
    const [saveConfigError, setSaveConfigError] = useState('');
    const [finalizingOnboarding, setFinalizingOnboarding] = useState(false);
    const [hideAiOnboarding, setHideAiOnboarding] = useState(false);

    // grab from param or set to be first step
    const {onboardingStepName = stepsOrder[0]} = useParams();

    const onboardingStep = stepsOrder.indexOf(onboardingStepName as WizardStep);

    const setOnboardingStep = useCallback((step: number) => {
        const step_name = stepsOrder[step];
        navigate(`/onboarding/${step_name}`);
    }, []);

    const [saving, setSaving] = useState(false);

    const saveData = useCallback(async () => {
        setSaving(true);
        try {
            await TenantConfigService.getInstance().updateOnboardingInfo(tenantConfigId, answers);
        } catch (err) {
            toast('danger', 'Error', getErrorMessage(err));
        } finally {
            setSaving(false);
        }
    }, [answers, tenantConfigId]);

    const finishSetup = useCallback(async () => {
        setFinalizingOnboarding(true);
        try {
            saveData();
            await TenantConfigService.getInstance().completeOnboarding();
            navigate('/');
        } catch (err) {
            toast('danger', 'Error', getErrorMessage(err));
        } finally {
            setFinalizingOnboarding(false);
        }
    }, [saveData]);

    const debouncedSave = useDebouncedCallback(saveData, 1000);

    useEffect(() => {
        if(!loading) {
            debouncedSave();
        }
    }, [answers, loading])
    
    const moveToStep = useCallback((step: number) => {
        setOnboardingStep(step);
    }, [saveData]);
    const saveAndContinue = useCallback(async () => {
        navigate('/onboarding/database');
    }, []);
    const validHost = useMemo(() => {
        const isValid = isValidSnowflakeURL(snowflakeDetails.host);
        return isValid;
    }, [snowflakeDetails.host]);

    const formIsValid = useMemo(() => {
        return validHost && !!snowflakeDetails.username && !!snowflakeDetails.database && !!snowflakeDetails.role && !!snowflakeDetails.query_warehouse;
    }, [snowflakeDetails, validHost]);

    const setSnowflakeValue = (key: keyof SnowflakeDetails, value: string) => {
        setSnowflakeDetails(produce(snowflakeDetails, draft => {
            draft[key] = value;
        }));
    }

    const saveSnowflakeDetails = useCallback(async () => {
        setSavingConfig(true);

        try {
            await TenantConfigService.getInstance().saveSnowflakeDetails(tenantConfigId, snowflakeDetails);
            setConfigSaved(true);
            setOnboardingStep(2);
        } catch (err) {
            setSaveConfigError(getErrorMessage(err));
        } finally {
            setSavingConfig(false);
        }
        
    }, [snowflakeDetails, tenantConfigId]);


   

    const onSetupComplete = useCallback(() => {
        if(useTemplate) {
            navigate(`/template/${useTemplate}?autouse=true`);
        }

    }, [useTemplate]);

   

    const [creatingPliableHostedGit, setCreatingPliableHostedGit] = useState(false);

    const savePliableGitSource = useCallback(async () => {
        setCreatingPliableHostedGit(true);

        try {
            const response = await TenantConfigService.getInstance().saveRepo(tenantConfigId, 'PLIABLE', '');
            await enterDraftMode('onboarding', false);

            // Reload the config so it doesn't redirect them to onboarding
            await ConfigService.getInstance().loadConfig();
        } catch (err) {
            setSaveConfigError(getErrorMessage(err));
        } finally {
            setCreatingPliableHostedGit(false);
        }
    }, [tenantConfigId]);

    const [stepStatuses, setStepStatuses] = useImmer<{[key: string]: string}>({
        'snowflake': '',
    });

    const [snowflakeAdminUsername, setSnowflakeAdminUsername] = useState('');
    const [snowflakeAdminPassword, setSnowflakeAdminPassword] = useState('');

    const [runningAutoSetup, setRunningAutoSetup] = useState(false);
    const autoSetup = useCallback(async () => {
        await saveSnowflakeDetails();
        console.log('Saved details');
        const res = await TenantConfigService.getInstance().autoSetupSnowflake(tenantConfigId, snowflakeAdminUsername, snowflakeAdminPassword);

        setOnboardingStep(1);
    }, [snowflakeDetails, tenantConfigId, snowflakeAdminUsername, snowflakeAdminPassword, saveSnowflakeDetails]);

    const [showAllTools, setShowAllTools] = useState(false);
    
    const [faded, setFaded] = useState(false);

    const [snowflakeConnectionIsValid, setSnowflakeConnectionIsValid] = useState(false);

    const changeStep = useCallback((step: number) => {
        TrackingService.track_event('onboarding_step', {
            step: step,
            answers: answers,
            snowflakeConnectionIsValid,
        });
        setOnboardingStep(step);
            
    }, [answers, saveData, savePliableGitSource, snowflakeConnectionIsValid]);


    const canGoNext = useMemo(() => {
        switch (onboardingStep) {
            case 0:
                return snowflakeConnectionIsValid;
            case 1:
                return false;
            case 2:
                return false;
            default:
                return true;
        }
    }, [snowflakeConnectionIsValid, onboardingStep, answers]);

    const onEventScheduled = useCallback((e: EventScheduledEvent) => {
        // setAnswers(draft => {
        //     draft.database.onboardingEventLink = e.data.payload.event.uri;
        //     draft.database.onboardingInviteeLink = e.data.payload.invitee.uri;
        //     queryClient.invalidateQueries(['calendly_onboarding_event'])
        // });
    }, []);

    useCalendlyEventListener({
       onEventScheduled: onEventScheduled,
    });

    const [bookCall, setBookCall] = useState(false);

    


    const authState = useAuthState();
    const innerContent = useMemo(() => {
        // if (answers.database.onboardingEventLink) {
        //     return <>
        //         <h1 className="mb-2">Your onboarding call is scheduled.</h1>
        //         <div className="shadow-box p-3">
        //             <CalendlyEventInfo eventUuid={answers.database.onboardingEventLink}/>
        //         </div>
                
        //     </>;
        // }

        

        if (onboardingStep == 0) {
            // Survey
            return <>
                <h1>Welcome to Pliable, the data organization platform for Snowflake.</h1>
                <h2 className="fw-light">We need to ask you some questions to personalize your experience.</h2>
                <Form.Group className="mb-3">
                    <Form.Label>How big is your data team?</Form.Label>
                    <Dropdown
                        options={
                            [
                                {
                                    label: "I don't have one",
                                    value: 'no_team',
                                },
                                {
                                    label: 'Just one person',
                                    value: 'just_one'
                                },
                                {
                                    label: '2-5 people',
                                    value: '2_5'
                                },
                                {
                                    label: '6-10 people',
                                    value: '6_10'
                                },
                                {
                                    label: '11-20 people',
                                    value: '11_20'
                                },
                                {
                                    label: '21+ people',
                                    value: '21_plus'
                                }
                            ]
                        }
                        selected={answers.dataTeamSize}
                        onChange={(value) => {
                            setAnswers(draft => {
                                draft.dataTeamSize = value;
                            });
                        }}
                    />
                    
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Which other tools do you have in your data stack?</Form.Label>
                    <MultiDropdown
                        options={toolOptions}
                        selected={answers.existingTools || []}
                        onChange={(value) => {
                            setAnswers(draft => {
                                draft.existingTools = value;
                            });
                        }}
                    />
                    <Form.Text>This will help us recommend the best integrations for your workflow.</Form.Text>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>What's your role at your company?</Form.Label>
                    <Dropdown
                        options={
                            [
                                {
                                    label: 'Data Analyst',
                                    value: 'data_analyst'
                                },
                                {
                                    label: 'Data Scientist',
                                    value: 'data_scientist'
                                },
                                {
                                    label: 'Data Engineer',
                                    value: 'data_engineer'
                                },
                                {
                                    label: 'Business Analyst',
                                    value: 'business_analyst'
                                },
                                {
                                    label: 'Product',
                                    value: 'product'
                                },
                                {
                                    label: 'Marketing',
                                    value: 'marketing'
                                },
                                {
                                    label: 'Sales',
                                    value: 'sales'
                                },
                                {
                                    label: 'HR',
                                    value: 'hr'
                                },
                                {
                                    label: 'Finance / Ops',
                                    value: 'finance_ops'
                                },
                                {
                                    label: 'Executive',
                                    value: 'executive'
                                },
                                {
                                    label: 'Other',
                                    value: 'other'
                                }
                            ]
                        }
                        selected={answers.role}
                        onChange={(value) => {
                            setAnswers(draft => {
                                draft.role = value;
                            });
                        }}
                    />
                    {answers.role == 'other' && <Form.Control 
                        className="mt-2"  
                        placeholder="Enter your role here" 
                        type="text" 
                        value={answers.otherRole} 
                        onChange={(e) => setAnswers(draft => {
                            draft.otherRole = e.target.value;
                        })}
                    />}
                </Form.Group>
                <div className="text-end">
                    <button 
                        className="btn btn-lg btn-light me-2"
                        onClick={async () => {
                            await saveData();
                            changeStep(onboardingStep + 1);
                        }}
                    >
                        Skip
                    </button>
                    <button 
                        className="btn btn-lg btn-pliable" 
                        onClick={async () => {
                            await saveData();
                            changeStep(onboardingStep + 1);
                        }}
                        disabled={!answers.dataTeamSize || !answers.existingTools || !answers.existingTools.length || !answers.role}>
                            Next
                        </button>
                </div>
                
            </>
        }

        if (onboardingStep == 1) {
            return <>
                
                <h1>Next: connect your Snowflake account.</h1>
                <h2 className="fw-light">Need to sign up for Snowflake? <a href="https://trial.snowflake.com/?owner=SPN-PID-724372" target="_blank">Click Here</a> for a free trial and come back once your account is created.</h2>
                <hr />
                <SnowflakeSetupForm
                    snowflakeDetails={snowflakeDetails}
                    onChange={setSnowflakeValue}
                    credsAreValid={snowflakeConnectionIsValid}
                    tenantConfigId={tenantConfigId}
                    showPliableHostedSnowflakeCode={showPliableHostedSnowflakeCode}
                    onCredentialsAreValid={(areValid) => {
                        setSnowflakeConnectionIsValid(areValid);
                    }}
                    onNextAfterValidation={() => {
                        changeStep(2);
                    }}
                />
            </>
        }

        if (onboardingStep == 2) {
            if (finalizingOnboarding) {
                return <LoadingCard action='Completing setup' />
            }
            
            return <>
                <h1 className="mb-5"><i className="mdi mdi-calendar"></i> Nice! Let's start your 14-day free trial</h1>
                <p>You'll get access to all of our features and can choose your plan later.</p>
                {/* <div className="mb-4">
                    <h4>Would you like to start with sample data?</h4>
                    <div className="row">
                        <div className="col-6">
                            <OnboardingOption onClick={() => setLoadSampleData(true)} className="shadow-box p-3 text-center" selected={answers.sampleData === true}>
                                <div><i className="mdi mdi-check-circle font-24"></i></div>
                                <h3>Yes, I want to use sample data</h3>
                                <p>Get started quickly with a pre-loaded dataset.</p>
                            </OnboardingOption>
                        </div>
                        <div className="col-6">
                            <OnboardingOption onClick={() => setLoadSampleData(false)} className="shadow-box p-3 text-center" selected={answers.sampleData === false}>
                                <div><i className="mdi mdi-close-circle font-24"></i></div>
                                <h3>No, I'll start from scratch</h3>
                                <p>Begin with a clean slate and add your own data.</p>
                            </OnboardingOption>
                        </div>
                    </div>
                </div> */}
                <div className="text-end">
                    <button className="btn btn-success btn-lg" onClick={finishSetup} >
                        Let's rock.
                    </button>
                </div>
                <Modal show={bookCall} onHide={() => setBookCall(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Book a call with a product expert</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InlineWidget
                            styles={{height: '800px', width: '100%'}}
                            url="https://calendly.com/d/ckc3-gd4-2wh/pliable-onboarding" 
                            prefill={{
                                email: authState?.email,
                                name: authState?.name,
                            }}
                            
                        />
                    </Modal.Body>
                </Modal>
            </>
        }
        return <>
            {onboardingStep == 0 && <>

            </>}
            {onboardingStep == 1 && <>
                {billingAccount && billingAccount.subscription_id}
                <CurrentBillingPlan billingAccount={billingAccount} onOptionSelected={async (bp) => {
                    const resp = await BillingAccountORM.selectBillingPlan(bp.default_price);
                    refetchBillingAccount();
                    setOnboardingStep(2);
                }} />
            </>}
            {onboardingStep == 2 && <>
                <h1>Payment Info</h1>
                {billingAccount && <EmbeddedCheckoutForm clientSecret={billingAccount.checkout_session_secret} /> }
            </>}
            {onboardingStep == 10 && <>
                <h1>That's it!</h1>
                {creatingPliableHostedGit && <>
                    <h2>
                        <i className="mdi mdi-loading mdi-spin"></i>
                        We're just running some final setup...
                    </h2>
                </>}
                {saveConfigError && <Danger>
                    {saveConfigError}    
                </Danger>}
                {!creatingPliableHostedGit && !saveConfigError && <>
                    <h2>You're all set!</h2>
                    <Link to="/node/new?sourceOnly=true">Add your first data source.</Link>
                </>}
                
            </>}
            {!creatingPliableHostedGit && <>
                <div className="d-flex center-vertically mt-3" >
                    {onboardingStep > 0 && <NextPreviousButton onClick={() => changeStep(onboardingStep - 1)}>&larr; Go Back</NextPreviousButton>}
                    <div className="flex-1"></div>
                    {onboardingStep < 10 &&  <NextPreviousButton disabled={!canGoNext} onClick={() => changeStep(onboardingStep + 1)}>Next &rarr;</NextPreviousButton>}
                    
                </div>
            </>}
            
        </>
    }, [onboardingStep, answers, setAnswers, snowflakeDetails, setSnowflakeValue, tenantConfigId, setSnowflakeConnectionIsValid, showAllTools, saveConfigError, creatingPliableHostedGit]);

    const logout = () => {
        navigate('/do/logout');
    }

    if (loading) {
        return <>
            <LoadingCard />
        </>
    }


    if (aiOnboardingEnabled && !hideAiOnboarding) {
        return <div style={{height: '100vh'}}>
            <Pane>
                <PaneContent>
                    <AiOnboarder onHide={() => setHideAiOnboarding(true)} />
                </PaneContent>
            </Pane>
        </div>  
    }
    

    return <div style={{height: '100vh'}}>
        <Pane>
            <PaneContent>
                <div className="p-5">
                    <img src={pliableLogo} style={{width: '200px'}} className="mx-2 mb-5"/>
                    {innerContent}
                </div>
            </PaneContent>
        </Pane>
        
    </div>  
}

export default OnboardingWizardPage;
